<template>
  <layout :session="session" :participant="participant">
    <div class="mt-6 sm:mt-0 py-5 flex flex-col items-center justify-center w-full">
      <div class="flex-1 h-full w-full max-w-sm mx-auto  px-4 select-none ">
        <textblock-multiple v-if="question.question_type == 'textblock_multiple'" :session="session"
          :translations="translations" :participant="participant" :question="question"
          :answerParameters="answerParameters"></textblock-multiple>

        <textblock-single v-if="question.question_type == 'textblock_single'" :session="session"
          :translations="translations" :participant="participant" :question="question"
          :answerParameters="answerParameters"></textblock-single>

        <keywords v-if="question.question_type == 'keywords'" :session="session" :translations="translations"
          :participant="participant" :question="question" :answerParameters="answerParameters"></keywords>

        <multiple-choice v-if="question.question_type == 'multiple_choice'" :session="session"
          :translations="translations" :participant="participant" :question="question"
          :answerParameters="answerParameters"></multiple-choice>

        <rating v-if="question.question_type == 'rating'" :session="session" :translations="translations"
          :participant="participant" :question="question" :answerParameters="answerParameters"></rating>

        <radio v-if="question.question_type == 'radio'" :session="session" :translations="translations"
          :participant="participant" :question="question" :answerParameters="answerParameters"></radio>


        <choices v-if="question.question_type == 'choices'" :session="session" :translations="translations"
          :participant="participant" :question="question" :answerParameters="answerParameters"></choices>
      </div>
    </div>


  </layout>
</template>

<script>
import Layout from '@/Pages/DiyWorkshop/Shared/Layout';
import Keywords from '@/Pages/DiyWorkshop/Questions/Keywords';
import MultipleChoice from '@/Pages/DiyWorkshop/Questions/MultipleChoice';
import TextblockMultiple from '@/Pages/DiyWorkshop/Questions/TextblockMultiple';
import TextblockSingle from '@/Pages/DiyWorkshop/Questions/TextblockSingle';
import Rating from '@/Pages/DiyWorkshop/Questions/Rating';
import Radio from '@/Pages/DiyWorkshop/Questions/Radio';
import Choices from '@/Pages/DiyWorkshop/Questions/Choices';
import { findIndex } from 'lodash';

export default {
  components: {
    Layout,
    Keywords,
    MultipleChoice,
    TextblockSingle,
    TextblockMultiple,
    Rating,
    Radio,
    Choices,
  },

  props: ['session', 'participant', 'question', 'phases', 'answerParameters', 'translations'],


  computed: {
    // question() {
    //   return this.phases[this.session.current_phase].question.question;
    // },

    // currentQuestion() {
    //   let idx = findIndex(this.phases, phase => {
    //     return (
    //       phase.type == 'question' && phase.id == this.session.current_phase
    //     );
    //   });

    //   return this.phases[idx] !== undefined ? this.phases[idx].question : null;
    // }
  }
};
</script>